import React from "react";

export default function ErrorMessage({ hasError, error }: { hasError: boolean; error?: string }) {
   return <>{hasError && <span className="error-message text-red-500 text-sm">{error}</span>}</>;
}
